module.exports = __webpack_public_path__ + "static/media/10_tn.5b86e6ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/10_tn.jpg
// module id = 319
// module chunks = 0